import packageJson from 'package.json'

export const getDbVersion = () => {
    return packageJson.dbVersion;
}
